import React, { Component } from 'react';
import SignupComponent from '../components/SignupComponent';
export default class Signup extends Component {
  render() {
    return (
      <SignupComponent/>
    );
  }
}